import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, renderList as _renderList, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { style: {"font-weight":"bold","margin-bottom":"4px"} }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "no-mb" }
const _hoisted_6 = { style: {"font-size":"12px","font-weight":"400"} }
const _hoisted_7 = {
  key: 1,
  class: "options-mobile"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import SubtotalWidget from '@/components/SubtotalWidget.vue'
import SubtotalMobileWidget from '@/components/SubtotalMobileWidget.vue'
import { useRouter } from 'vue-router'
import { computed, onMounted } from 'vue'
import { generalStore } from '@/stores/general'
import { subtotalStore } from '@/stores/subtotal'
import { headerStore } from '@/stores/header'
import { authStore } from '@/stores/auth'
import { modularStore } from '@/stores/modular'
import { WarningTwoTone } from '@ant-design/icons-vue'
import ListOption from '@/components/ListOption.vue'
import UnityWidget from '@/components/dashboard/UnityWidget.vue'
import { ls } from '@/ls'


export default /*#__PURE__*/_defineComponent({
  __name: 'Modular',
  setup(__props) {

const router = useRouter()

const building = computed(() => ls.get('building'))
const isInternalTestAccount = computed(() => authStore().isInternalTestAccount)
const showOptions = computed(() => !['loading', 'test'].includes(modularStore().phaseState) || isInternalTestAccount.value)

const columns = [
  {
    title: 'Optie',
    key: 'external_ref',
    width: 80
  },
  {
    title: 'Omschrijving',
    key: 'option'
  },
  {
    title: 'Prijs incl. BTW',
    key: 'price',
    width: 130
  },
  {
    title: '',
    key: 'actions',
    width: 176
  }
]

onMounted(() => {
  modularStore().getPhaseState()
  modularStore().getOptions()
})

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_row, { gutter: [16,4] }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          xs: {span: 24},
          sm: {span: 24},
          md: {span: 24},
          lg: {span: 18}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, {
              title: "Modulaire opties",
              loading: _unref(modularStore)().loading
            }, {
              extra: _withCtx(() => [
                (_unref(building)?.unity_enabled && _unref(building)?.model_available)
                  ? (_openBlock(), _createBlock(UnityWidget, {
                      key: 0,
                      style: { marginRight: '8px' }
                    }))
                  : _createCommentVNode("", true),
                (_unref(generalStore)().desktop)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 1,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'Dashboard' })))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Terug naar dashboard")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                (['loading', 'test', 'demo', 'closed'].includes(_unref(modularStore)().phaseState) || _unref(authStore)().isDemoCustomer)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            (_unref(modularStore)().phaseState === 'test' && !_unref(isInternalTestAccount))
                              ? (_openBlock(), _createBlock(_component_a_alert, {
                                  key: 0,
                                  type: "info",
                                  message: "Er zijn voor deze fase (nog) geen opties beschikbaar.",
                                  description: "Deze opties worden op een later moment zichtbaar.",
                                  "show-icon": ""
                                }))
                              : _createCommentVNode("", true),
                            (_unref(modularStore)().phaseState === 'demo' || _unref(authStore)().demoEnvironment)
                              ? (_openBlock(), _createBlock(_component_a_alert, {
                                  key: 1,
                                  type: "info",
                                  message: "U bevindt zich in de demo omgeving.",
                                  description: "U kunt (nog) geen definitieve bestelling plaatsen voor deze fase.",
                                  "show-icon": ""
                                }))
                              : _createCommentVNode("", true),
                            (_unref(modularStore)().phaseState === 'closed' && _unref(headerStore)().ordersReceived.modular && !_unref(authStore)().demoEnvironment)
                              ? (_openBlock(), _createBlock(_component_a_alert, {
                                  key: 2,
                                  type: "success",
                                  message: "Bestelling succesvol ontvangen.",
                                  "show-icon": ""
                                }, {
                                  description: _withCtx(() => [
                                    _createTextVNode(" Wij hebben uw bestelling voor de modulaire opties succesvol ontvangen."),
                                    _hoisted_1,
                                    (!_unref(generalStore)().desktop)
                                      ? (_openBlock(), _createElementBlock("br", _hoisted_2))
                                      : _createCommentVNode("", true),
                                    _createTextVNode(" Het is niet meer mogelijk om uw modulaire opties te wijzigen. Dit is om de voortgang van het bouwproces te continueren. ")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_unref(modularStore)().phaseState === 'closed' && !_unref(headerStore)().ordersReceived.modular && !_unref(authStore)().isDemoCustomer)
                              ? (_openBlock(), _createBlock(_component_a_alert, {
                                  key: 3,
                                  type: "error",
                                  message: "Deze fase is gesloten maar wij hebben geen bestelling ontvangen!",
                                  "show-icon": ""
                                }, {
                                  description: _withCtx(() => [
                                    _createTextVNode(" Neem zo spoedig mogelijk contact op met Hofzicht Makelaars via telefoonnummer 0252 - 530119. ")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(showOptions))
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            (_unref(generalStore)().desktop)
                              ? (_openBlock(), _createBlock(_component_a_table, {
                                  key: 0,
                                  columns: columns,
                                  "data-source": _unref(modularStore)().options,
                                  pagination: false
                                }, {
                                  bodyCell: _withCtx(({ column, record }) => [
                                    (column.key === 'external_ref')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(_toDisplayString(record.external_ref), 1)
                                        ], 64))
                                      : _createCommentVNode("", true),
                                    (column.key === 'option')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createElementVNode("p", _hoisted_3, [
                                            _createTextVNode(_toDisplayString(record.name_sales) + " ", 1),
                                            (record.excluded_from_warranty)
                                              ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 0 }, {
                                                  title: _withCtx(() => [
                                                    _createTextVNode("Deze optie is uitgesloten van de toepasselijke Woningborg Garantie- en waarborgregeling.")
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _createVNode(_unref(WarningTwoTone), {
                                                      "two-tone-color": "#f38929",
                                                      style: {"margin-left":"4px"}
                                                    })
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createElementVNode("div", {
                                            innerHTML: record.text_sales
                                          }, null, 8, _hoisted_4)
                                        ], 64))
                                      : _createCommentVNode("", true),
                                    (column.key === 'price')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                          _createElementVNode("p", _hoisted_5, "€ " + _toDisplayString(record.price.toLocaleString('nl-NL')), 1),
                                          _createElementVNode("p", _hoisted_6, "incl. " + _toDisplayString(record.vat_rate) + "% BTW", 1)
                                        ], 64))
                                      : _createCommentVNode("", true),
                                    (column.key === 'actions')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                          (!record.selected && !_unref(modularStore)().isDisabled[record.id])
                                            ? (_openBlock(), _createBlock(_component_a_button, {
                                                key: 0,
                                                loading: _unref(modularStore)().savingId === record.id,
                                                disabled: _unref(authStore)().restricted() || record.frozen || _unref(modularStore)().savingId !== 0 || _unref(modularStore)().removingId !== 0 || _unref(modularStore)().phaseIsClosed,
                                                onClick: ($event: any) => (_unref(modularStore)().selectOption(record))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_unref(modularStore)().phaseIsClosed ? 'Niet gekozen' : 'Kies'), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["loading", "disabled", "onClick"]))
                                            : (!record.selected && _unref(modularStore)().isDisabled[record.id])
                                              ? (_openBlock(), _createBlock(_component_a_button, {
                                                  key: 1,
                                                  disabled: true
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_unref(modularStore)().phaseIsClosed ? 'Niet gekozen' : 'Niet beschikbaar'), 1)
                                                  ]),
                                                  _: 1
                                                }))
                                              : (record.selected)
                                                ? (_openBlock(), _createBlock(_component_a_button, {
                                                    key: 2,
                                                    type: "primary",
                                                    class: "option-btn",
                                                    loading: _unref(modularStore)().removingId === record.id,
                                                    disabled: _unref(authStore)().restricted() || record.frozen || _unref(modularStore)().savingId !== 0 || _unref(modularStore)().removingId !== 0 || _unref(modularStore)().phaseIsClosed,
                                                    onClick: ($event: any) => (_unref(modularStore)().unselectOption(record))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("Gekozen")
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["loading", "disabled", "onClick"]))
                                                : _createCommentVNode("", true)
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }, 8, ["data-source"]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(modularStore)().options, (o) => {
                                    return (_openBlock(), _createBlock(ListOption, {
                                      option: o,
                                      key: o.id
                                    }, {
                                      buttons: _withCtx(() => [
                                        (!o.selected && !_unref(modularStore)().isDisabled[o.id])
                                          ? (_openBlock(), _createBlock(_component_a_button, {
                                              key: 0,
                                              loading: _unref(modularStore)().savingId === o.id,
                                              disabled: _unref(authStore)().restricted() || o.frozen || _unref(modularStore)().savingId !== 0 || _unref(modularStore)().removingId !== 0 || _unref(modularStore)().phaseIsClosed,
                                              onClick: ($event: any) => (_unref(modularStore)().selectOption(o))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_unref(modularStore)().phaseIsClosed ? 'Niet gekozen' : 'Kies'), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["loading", "disabled", "onClick"]))
                                          : (!o.selected && _unref(modularStore)().isDisabled[o.id])
                                            ? (_openBlock(), _createBlock(_component_a_button, {
                                                key: 1,
                                                disabled: true
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_unref(modularStore)().phaseIsClosed ? 'Niet gekozen' : 'Niet beschikbaar'), 1)
                                                ]),
                                                _: 1
                                              }))
                                            : (o.selected)
                                              ? (_openBlock(), _createBlock(_component_a_button, {
                                                  key: 2,
                                                  type: "primary",
                                                  class: "option-btn",
                                                  loading: _unref(modularStore)().removingId === o.id,
                                                  disabled: _unref(authStore)().restricted() || o.frozen || _unref(modularStore)().savingId !== 0 || _unref(modularStore)().removingId !== 0 || _unref(modularStore)().phaseIsClosed,
                                                  onClick: ($event: any) => (_unref(modularStore)().unselectOption(o))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("Gekozen")
                                                  ]),
                                                  _: 2
                                                }, 1032, ["loading", "disabled", "onClick"]))
                                              : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["option"]))
                                  }), 128))
                                ]))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, {
                          span: 24,
                          style: _normalizeStyle(_unref(generalStore)().desktop ? { padding: '8px', textAlign: 'right' } : {})
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("b", {
                              style: _normalizeStyle(_unref(generalStore)().desktop ? { marginRight: 32 } : {})
                            }, "Totaal modulaire opties:", 4),
                            _createTextVNode(),
                            (!_unref(generalStore)().desktop)
                              ? (_openBlock(), _createElementBlock("br", _hoisted_8))
                              : _createCommentVNode("", true),
                            _createTextVNode(" € " + _toDisplayString(_unref(subtotalStore)().subtotals.modular), 1)
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        (_unref(modularStore)().phaseState === 'open' && _unref(modularStore)().options.length && !_unref(authStore)().isDemoCustomer)
                          ? (_openBlock(), _createBlock(_component_a_col, {
                              key: 0,
                              span: 24
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_divider),
                                _createVNode(_component_a_row, { style: {"margin-bottom":"0"} }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_col, { span: 24 }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("p", {
                                          style: _normalizeStyle(_unref(generalStore)().desktop ? { margin: '0 0 0 24px' } : { margin: '0' })
                                        }, [
                                          _createTextVNode("De extra opties zijn een aanvulling op de tussen de ondernemer en verkrijger gesloten (koop-) aannemingsovereenkomst."),
                                          _hoisted_9,
                                          _createTextVNode("De Woningborg Garantie- en waarborgregeling is tevens van toepassing op de gekozen extra opties.")
                                        ], 4)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_divider),
                                _createVNode(_component_a_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_col, { span: 24 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_checkbox, {
                                          disabled: _unref(authStore)().restricted(),
                                          checked: _unref(modularStore)().agreeToTerms,
                                          onChange: _cache[1] || (_cache[1] = ($event: any) => (_unref(modularStore)().agreeToTerms = !_unref(modularStore)().agreeToTerms))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Ik/wij ga(an) ermee akkoord dat met het versturen van de opties opdracht gegeven wordt tot de uitvoering van meer- (en minder)werk en dat na de sluitingsdatum deze opties niet meer gewijzigd kunnen worden.")
                                          ]),
                                          _: 1
                                        }, 8, ["disabled", "checked"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_row, { class: "no-mb" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_col, { span: 24 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_button, {
                                          type: "primary",
                                          loading: _unref(modularStore)().creatingOrder,
                                          disabled: _unref(authStore)().restricted() || !_unref(modularStore)().agreeToTerms,
                                          style: _normalizeStyle(_unref(generalStore)().desktop ? { float: 'right' } : { width: '100%' }),
                                          onClick: _unref(modularStore)().createOrder
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Modulair - Bestelling plaatsen")
                                          ]),
                                          _: 1
                                        }, 8, ["loading", "disabled", "style", "onClick"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        }),
        (_unref(generalStore)().desktop)
          ? (_openBlock(), _createBlock(_component_a_col, {
              key: 0,
              span: 6
            }, {
              default: _withCtx(() => [
                _createVNode(SubtotalWidget)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (!_unref(generalStore)().desktop)
      ? (_openBlock(), _createBlock(SubtotalMobileWidget, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})